export default __webpack_public_path__ + "media/images/gallery/23-3244e979570fc720a8bef22affc7cd92.jpg";